import { useField, useFormikContext } from 'formik'
import { SourceMaterialSelect } from 'components/DocRightRail/screens/AIAssistant/SourceMaterialSelect'
import { useSourceMaterials } from 'hooks/useSourceMaterials'
import { FormStatus } from 'components/Wizards/Wizard/Form/Types'
import { FormButton } from '../FormButton/FormButton'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import Styles from './Field.module.scss'
import { TextFieldLoadingState } from 'components/Wizards/TextFieldLoadingState/TextFieldLoadingState'

export const SourceMaterialInput = () => {
  const sourceMaterials = useSourceMaterials()
  const [sourceMaterialIdsField, , { setValue: setSourceMaterialIds }] = useField('source_material_ids')
  const { status } = useFormikContext()
  const { isMobile } = useResponsiveDesign()

  if (status === FormStatus.AutoFilling) {
    return <TextFieldLoadingState fixedWidth={300} />
  }

  return (
    <SourceMaterialSelect
      onChange={setSourceMaterialIds}
      selectedSourceMaterials={sourceMaterialIdsField.value}
      sourceMaterials={sourceMaterials.data || []}
      ButtonComponent={isMobile ? FormButton : undefined}
      popoverClassName={Styles.popoverClassName}
    />
  )
}
